import { Dispatch } from "@reduxjs/toolkit";
import { addUserOnboardingFormResponse } from "../graphql/mutations/onBoarding";
import {
  getOnboardingDataSchema,
  getUserResponses,
} from "../graphql/queries/onBoarding";
import { apolloClient } from "../startup/apollo";
import onboardingData from "../store/onboarding.json";
import { setFormResponses } from "../store/onBoarding/onBoardingSlice";

export const getOnboardingData = async () => {
  try {
    const response = await apolloClient.query({
      query: getOnboardingDataSchema,
    });

    return response.data.getOnboardingData.data;
  } catch (error: any) {
    throw new Error(`Failed to fetch onboarding data: ${error.message}`);
  }
};

export const createOnboardingData = async () => {
  try {
    const response = await apolloClient.mutate({
      mutation: addUserOnboardingFormResponse,
      variables: onboardingData,
    });

    return response.data.createOnboardingData.data;
  } catch (error: any) {
    throw new Error(`Failed to fetch onboarding data: ${error.message}`);
  }
};
